import * as React from 'react'
import { Routes, Route } from 'react-router-dom'

import { AuthenticatedDashboard } from 'pages/dashboard/main'
import { DisplayType, OpensClicksDashboard } from '../pages/dashboard/engagement'
import { Topics } from '../pages/topics/main'

import { App } from './home'

const ENGAGEMENT_PATH: string = 'engagement'
const CHART_ENGAGEMENT_PATH: string = `${ENGAGEMENT_PATH}/chart`
const TABLE_ENGAGEMENT_PATH: string = `${ENGAGEMENT_PATH}/table`

const authenticatedComponent = (path: string, component: any) => {
  return <AuthenticatedDashboard path={path}>
    {component}
  </AuthenticatedDashboard>
}

const authenticatedRoute = (path: string, component: any) => {
  return <Route path={path} element={authenticatedComponent(path, component)}/>
}

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      {authenticatedRoute(ENGAGEMENT_PATH, <OpensClicksDashboard display={DisplayType.All}/>)}
      {authenticatedRoute(CHART_ENGAGEMENT_PATH, <OpensClicksDashboard display={DisplayType.Chart}/>)}
      {authenticatedRoute(TABLE_ENGAGEMENT_PATH, <OpensClicksDashboard display={DisplayType.Table}/>)}
      <Route path="topics" element={<Topics />} />
      <Route path="*"
              element={
                <main style={{ padding: '1rem' }}>
                  <p>There's nothing here!</p>
                </main>
              }
            />
    </Routes>
  )
}
